import React, { Component } from "react";
import { FormGroup, FormControl, ControlLabel, Breadcrumb } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import config from "../config";
import "./NewProject.css";
import { API, Storage } from "aws-amplify";
import { s3UploadBlob } from "../libs/awsLib";


import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';

import loaderIcon from'../images/ftc_logo.gif';


export default class NewProject extends Component {
  constructor(props) {
    super(props);

console.log(props);

    this.file = null;
    const isEditing = this.props.location.state && this.props.location.state.projectId;
    this.state = {
      isEditing: false,
      isLoading: isEditing,
      isSaving: null,
      project: null,
      title: "",
      logo: "",
      attachmentURL: null,
      description: "",
      active: false,
      currentSchemaVersion: 0,
      alertOpen: false
    };
}

  async componentDidMount() {
  if (!this.props.isAuthenticated) {
    return;
  }


    //var pId;
    if (this.props.location.state) {
      if (this.props.location.state.projectId) {
        this.pId = this.props.location.state.projectId

         try {
          let attachmentURL;
          const project = await this.getProject(this.pId);
          const { title, logo, description, currentSchemaVersion, schemas, active } = project;


          console.log(project);
          let schemaVersion = currentSchemaVersion;
          if (logo) {
            attachmentURL = await Storage.get(logo);
          }
          if (schemas.length === 0) {
            let scm = await this.createNewSchemaVersion();
            console.log(scm);
            let newSchemas = [{id: this.getSchemaIdFromSk(scm.sk), version: 1, notes: " ", active: false}];
            schemaVersion = 1;
            project.schemas = newSchemas;
            await this.updateProject(this.pId, {
              title: title,
              logo: logo,
              description: description,
              active: active,
              currentSchemaVersion: schemaVersion,
              schemas: newSchemas
            });
          }

          this.setState({
            isEditing: true,
            isLoading: false,
            project,
            schemas: schemas,
            title: title,
            logo: logo,
            attachmentURL,
            description: description,
            currentSchemaVersion: schemaVersion,
            active: active
          });
        } catch (e) {
          alert(e);
        }


      }
    }




  }
  getProject(projectId) {
    if (this.props.org) {
      return API.get("ftc", `/organisations/${this.props.org.pk}/projects/${projectId}`);
    } else {
      return API.get("ftc", `/organisations/user/projects/${projectId}`);
    }
  }

  createNewSchemaVersion() {
    return API.post("ftc", "/projects/schemas", {
      body: { orgId: this.props.org ? this.props.org.pk : null }
    });
  }

  getSchemaIdFromSk(sk) {
    return sk.substr(4);
  }


  updateProject(projectId, body) {
    try{
      if (this.props.org) {
        return API.put("ftc", `/organisations/${this.props.org.pk}/projects/${projectId}`, {body: body});
      } else {
        return API.put("ftc", `/organisations/user/projects/${projectId}`, {body: body});
      }
    }catch(e) {
      console.log(e);
    }
  }

validateChangesOnly() {
  console.log(this.file, this.state.project.logo);

  return this.validateForm() && (this.state.title !== this.state.project.title || this.state.description !== this.state.project.description || this.file != null || this.state.active !== this.state.project.active);
}

  validateForm() {
    const t = this.state.title.trim();
    const d = this.state.description.trim();

    return d.length > 0 && t.length > 0;
  }

handleReset = event => {
  event.preventDefault();
  this.file = null;
  this.inputEl.value='';
  this.setState({
    title: this.state.project.title,
    description: this.state.project.description,
    logo: this.state.project.logo,
    active: this.state.project.active
  });


}
toggleCheckboxChange = event => {
  console.log(event.target.id,event.target.checked,event.target.value)
  this.setState({
    active: event.target.checked
  });
}


  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleFileChange = event => {
    this.file = event.target.files[0];
    if (this.file && this.file.type.indexOf("image") == -1) {
      this.file = null;
      this.inputEl.value='';
      this.setState({
        alertOpen: true,
        alertTitle: 'Invalid Image Format',
        alertMessage: 'Please choose a valid image for the project logo.'
      });
    } else {
      this.setState({

      });
    }
  }

handleSubmit = async event => {
  event.preventDefault();

  if (this.file && this.file.size > config.MAX_ATTACHMENT_SIZE) {
    this.setState({
      alertOpen: true,
      alertTitle: 'Invalid Image File Size',
      alertMessage: 'Please choose a file smaller than 5MB.'
    });
    return;
  }

  this.setState({ isSaving: true });

  try {
    console.log("+++");
    let attachment = null;
    if (this.file) {
      const blob = await this.getReducedImageAsBlob(this);
      let orgId = '';
      if (this.props.org) {
        orgId = this.props.org.pk;
      } else {
        orgId = this.props.user.pk;
      }

      attachment = await s3UploadBlob(orgId, this.file, blob);
      console.log(attachment);
      console.log("***");
    }




    //const attachment = this.file
    //  ? await this.uploadReducedImage(this, this.file)
    //  : null;
      console.log("---");
    if (this.state.isEditing) {
      await this.updateProject(this.pId, {
        title: this.state.title.trim(),
        logo: attachment ? attachment : this.state.logo,
        description: this.state.description.trim(),
        active: this.state.active,
        currentSchemaVersion: this.state.currentSchemaVersion,
        schemas: this.state.schemas
      });
    } else {
      await this.createProject({
        orgId: this.props.org ? this.props.org.pk : null,
        attachment,
        title: this.state.title.trim(),
        description: this.state.description.trim(),
        active: this.state.active
      });
    }
    this.props.history.push("/projects");
  } catch (e) {
    this.setState({
      alertOpen: true,
      alertTitle: 'Error',
      alertMessage: e.message,
      isSaving: false
    });
  }
}
getReducedImageAsBlob(context) {
  var reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject(null);
    };
    reader.onload = () => {
      var img = new Image();
      img.onload = function() {
          console.log('IMG: ', img.height, img.width);
          let h = 200;
          let w = 200;
          if (img.height > img.width) {
            w = w * (img.width / img.height);
          } else {
            h = h * (img.height / img.width);
          }
          var oc = document.createElement('canvas');
          oc.width = w;
          oc.height = h;
          oc.getContext('2d').drawImage(img, 0, 0, w, h);
          var dataurl = oc.toDataURL(context.file.type);
          //console.log(dataurl);
          var blob = context.dataURItoBlob(dataurl, context.file.type);
          resolve(blob);
        }
      img.src = reader.result
      };
    reader.readAsDataURL(context.file);
  });
}

dataURItoBlob(dataURI, fileType) {
    var binary = atob(dataURI.split(',')[1]);
    var array = [];
    for(var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], {type: fileType});
}

createProject(project) {
  return API.post("ftc", "/projects", {
    body: project
  });
}

handleAlertClose = () => {
    this.setState({ alertOpen: false });
};
handleCrumbClick = event => {
  event.preventDefault();
  this.props.history.push(event.currentTarget.getAttribute("href"));
}

renderFields() {
  return(
    <div className="NewProject" style={{position: 'absolute', left:80, right:80,top: 110}}>
       <form onSubmit={this.handleSubmit}>
         <FormGroup controlId="title">
         <ControlLabel>Project title</ControlLabel>
           <FormControl
             onChange={this.handleChange}
             value={this.state.title}
             componentClass="input"
             type="text"
           />
         </FormGroup>


         <FormGroup controlId="description">
         <ControlLabel>Project description</ControlLabel>
           <FormControl
             onChange={this.handleChange}
             value={this.state.description}
             componentClass="textarea"
           />
         </FormGroup>




         {!this.file && this.state.logo &&
           <FormGroup>
             <ControlLabel>Project Logo</ControlLabel>
             <FormControl.Static >
                 <img src={this.state.attachmentURL} style={{maxWidth: '400px'}} height='80px' alt="Project Logo"/>
             </FormControl.Static>
           </FormGroup>
         }
         <FormGroup controlId="file">
           {(this.file || !this.state.logo) &&
             <ControlLabel>Project Logo</ControlLabel>}
           <FormControl inputRef={ el => this.inputEl=el }  onChange={this.handleFileChange} type="file" />
         </FormGroup>

         <FormGroup controlId="active">
         <ControlLabel>Live&nbsp;</ControlLabel>
           <input
             type="checkbox"
             disabled={!this.state.isEditing}
             id={0}
             checked={this.state.active}
             onChange={this.toggleCheckboxChange}
           />
         </FormGroup>



         {this.state.isEditing ?
           <div>
                     <LoaderButton

           bsStyle="primary"
           bsSize="large"
           disabled={!this.validateChangesOnly()}
           type="submit"
           isLoading={this.state.isSaving}
           text="Save"
           loadingText="Saving…"
         />

         <LoaderButton


           bsSize="large"
           disabled={!this.validateChangesOnly()}
           isLoading={false}
           text="Cancel"
           onClick={this.handleReset}
           loadingText="Cancelling…"
         />
         </div>
         :
         <LoaderButton
           bsStyle="primary"
           bsSize="large"
           disabled={!this.validateForm()}
           type="submit"
           isLoading={this.state.isSaving}
           text="Create"
           loadingText="Creating new project…"
         />}






       </form>
     </div>
  )
}
  renderLoader() {
    const label = 'loading...';
    return(

      <div id="splash" style={{paddingTop: 250, zIndex:999}}>

        <center id="splash">
          <img src={loaderIcon}/>
          <Typography style={{padding: '4px'}} variant="caption">{label}</Typography>
        </center>
      </div>



    )
  }


  render() {
    return (
      <div>
         <Breadcrumb style={{top: 58, left: 66, right: 0, position: 'fixed', zIndex:999, backgroundColor: '#FFF'}}>
          <Breadcrumb.Item onClick={this.handleCrumbClick} href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item onClick={this.handleCrumbClick} href="/projects">Projects</Breadcrumb.Item>
          <Breadcrumb.Item active>{this.state.isLoading ? '' : this.state.project && this.state.project.title ? 'Edit: ' + this.state.project.title : 'Create new'}</Breadcrumb.Item>
        </Breadcrumb>

        {this.state.isLoading ? this.renderLoader() : this.renderFields()}


      <Dialog
          open={this.state.alertOpen}
          onClose={this.handleAlertClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{this.state.alertTitle}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.state.alertMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleAlertClose} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/NewProject.js